import * as THREE from 'three'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useThree } from '@react-three/fiber'
import { useTexture } from '@react-three/drei'

import { const_var, params } from '../../../../redux/reducers/reducer'
import { setMainTrussPosInfo } from '../../../../action'
import { ReflectLegTextureNX, ReflectLegTextureNY, ReflectLegTextureNZ, ReflectLegTexturePX, ReflectLegTexturePY, ReflectLegTexturePZ, TrussRailTextureImg } from '../../../../utils/Textures'
import { textureAnisotropy } from '../../../../utils/Functions'

import ACDT from './ACDT'
import ACT from './ACT'
import CTCT from './CTCT'
import ECT from './ECT'
import LST_RNT from './LST_RNT'
import QCT from './QCT'
import SBST from './SBST'
import TWCT from './TWCT'
import AST from './AST'
import LCT from './LCT'
import CMT from './CMT'
import Standard from './Standard'

const Truss = ({ overlapTrussArr }) => {
    const dispatch = useDispatch();
    
    const { gl } = useThree();
    const [hiddenBaseRailIdArr, setHiddenBaseRailIdArr] = useState([]);
    const nMap = useTexture( process.env.REACT_APP_BASE_URL+TrussRailTextureImg);

    // const tempTrussType = ['TWCT', 'ACDT', 'ACT', 'AST', 'CTCT', 'ECT', 'LADDER', 'LST', 'RNT', 'QCT', 'SBST'];
    // const trussType = 'CMT'

    const trussType = useMemo(() => {
        let trussObj = const_var.a_p_d_a?.truss_name
        let trussName = ""
        if(trussObj != undefined && trussObj.length > 0){
            trussObj.forEach((item)=>{
                if(item.is_show == 1 && (params.trussType == item.name.replace(/[0-9]/g, ''))){
                    trussName = item.name.replace(/[0-9]/g, '')
                }else{
                    trussName = (params.p_b_t === 27) ? 'Standard' : (params.p_w > 30) ? (!params.singleSlope ? params.trussType : "") : ((params.p_w > 24 && params.p_w <= 30) && !params.singleSlope) ? "TWCT" : ""
                }
            })
        }
        
        // return (params.p_b_t === 27) ? 'Standard' : (params.p_w > 30) ? (!params.singleSlope ? params.trussType : "") : ((params.p_w > 24 && params.p_w <= 30) && !params.singleSlope) ? "TWCT" : ""
        // return (const_var.a_p_d_a?.truss_name?.length > 1 ) ? params["trussType"] : (params.p_b_t === 27) ? 'Standard' : (params.p_w > 30) ? (!params.singleSlope ? params.trussType : "") : ((params.p_w > 24 && params.p_w <= 30) && !params.singleSlope) ? "TWCT" : ""
        return trussName
    }, [params.p_b_t, params.p_w, params.trussType, params.singleSlope,const_var.a_p_d_a?.truss_name?.length]);
    
    const trussTexture = useMemo(() => {
        let envMap = const_var.envIMG
        textureAnisotropy(gl, envMap, 1, 1, 0)
        return envMap
    }, []);
    
    const norMap = useMemo(() => {
        let normalMap = nMap
        textureAnisotropy(gl, normalMap, 1, 1, Math.PI / 2)
        return normalMap
    }, []);

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])
    
    const trussModelPosInfoArr = useMemo(() => {
        let count, distance = 0;
        
        const initDistance = legDistance;
        const tempCount = Math.floor(params.p_d / initDistance);
        if (params.p_d === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (params.p_d - tempCount * initDistance < initDistance / 2) {
            count = tempCount;
            distance = params.p_d / count;
        } else {
            count = tempCount + 1;
            distance = params.p_d / count;
        }
        
        const posInfoArr = Array.from({ length: count + 1 }, (_, index) => distance * index - params.p_d / 2)

        if (posInfoArr.length > 0) dispatch(setMainTrussPosInfo(posInfoArr))

        return posInfoArr
    }, [params.p_d, legDistance, params.trussType])

    
    useEffect(() => {
        if(const_var.c_m_a[params.p_b_t] != undefined && (params.newtrussType == undefined || params.newtrussType=='')){
            if(const_var.c_m_a[params.p_b_t].trussType!=undefined && const_var.c_m_a[params.p_b_t].trussType.length > 0){
                if(const_var.c_m_a[params.p_b_t].trussType.length == 1){
                    params["trussType"] = const_var.c_m_a[params.p_b_t].trussType[0].name.replace(/[0-9]/g, '')
                }else{
                    let filterDatan = const_var.c_m_a[params.p_b_t].trussType.filter(data=>data.name.includes(params.trussType));
                    let defaultTruss  = const_var.c_m_a[params.p_b_t]?.trussType?.find((data) => data.is_show == 0)
                    params["trussType"] = (filterDatan?.length>0 && const_var.crmSetting.is_Edit == true)?filterDatan[0].name.replace(/[0-9]/g, ''): defaultTruss?.name?.replace(/[0-9]/g, '')
                }
            }
        }
    }, [params.p_b_t, params.newtrussType, params.trussType])    

    useEffect(() => {
        if(const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].trussType!=undefined && const_var.c_m_a[params.p_b_t].trussType.length > 0){
            let checkTruss =  const_var.c_m_a[params.p_b_t].trussType.filter(data=> params.p_w <= data.max_width && params.p_w >= data.min_width);
            if(checkTruss.length == 0){
                params["trussType"] = 'ECT'
            }
        }
    }, [params.p_b_t, params.newtrussType, params.trussType,params.p_w]);

    useMemo(() => {
        let isHiddenBaseRailIndexArr = [];
        const heightestDoorArr = const_var.newDoorsArray.filter(e => (e.height > params.p_h) || (e.positionY + e.height / 2 >= params.p_h));
        
        if(heightestDoorArr.find(item => item.userData.wallName === 'c_b_f_w')) isHiddenBaseRailIndexArr.push(trussModelPosInfoArr?.length - 1)
        if(heightestDoorArr.find(item => item.userData.wallName === 'c_b_b_w')) isHiddenBaseRailIndexArr.push(0)
        if(params.p_d % legDistance === 0){
            if(heightestDoorArr.find(item => item.userData.wallName === 'c_b_f_s_w')) isHiddenBaseRailIndexArr.push(parseInt(params.p_u_t) / legDistance)
        }
        
        setHiddenBaseRailIdArr(isHiddenBaseRailIndexArr);
    }, [params.p_h, const_var.newDoorsArray, params.p_u_t, params.p_d, params.fourth_center_cost, legDistance])

    switch (trussType) {
        case "TWCT":
            return <TWCT normalMap={norMap} envMap={trussTexture} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr}/>
        case "ACDT":
            return <ACDT normalMap={norMap} envMap={trussTexture} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr}/>
        case "ACT":
            return <ACT normalMap={norMap} envMap={trussTexture} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr}/>
        case "AST":
            return <AST normalMap={norMap} envMap={trussTexture} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr}/>
        case "CTCT":
            return <CTCT normalMap={norMap} envMap={trussTexture} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr}/>
        case "ECT":
            return <ECT normalMap={norMap} envMap={trussTexture} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr}/>
        case "LCT":
            return <LCT normalMap={norMap} envMap={trussTexture} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr}/>
        case "LST": 
        case "RNT":
            return <LST_RNT normalMap={norMap} envMap={trussTexture} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr}/>
        case "QCT":
            return <QCT normalMap={norMap} envMap={trussTexture} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr}/>
        case "SBST":
            return <SBST normalMap={norMap} envMap={trussTexture} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr}/>
        case "CMT":
            return <CMT normalMap={norMap} envMap={trussTexture} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr}/>
        default:
            return <Standard normalMap={norMap} envMap={trussTexture} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr}/>
    }
}

export default Truss
